exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SpfButton_btn_1E3y {\n  color: #fff;\n  background: #0e0737 !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n\n.SpfButton_btn__content_1LnZ {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.SpfButton_btn__text_jhRm {\n  margin-right: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"btn": "SpfButton_btn_1E3y",
	"btn__content": "SpfButton_btn__content_1LnZ",
	"btn__text": "SpfButton_btn__text_jhRm"
};